<template>
  <div class="tab-container">
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default table-default--40"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__name><div class="table-default__left">Position</div></template>
        <template #name="{ row }"><div class="table-default__left">{{ row.position.name }}</div></template>
        <template #planned="{ row }">{{ amountFormat(row.planned_count) }}</template>
        <template #real="{ row }">{{ amountFormat(row.real_count) }}</template>
        <template #assigned="{ row }">{{ amountFormat(row.assigned_count) }}</template>
        <template #weight="{ row }">{{ amountFormat(row.weight) }}</template>
        <template #controls="{ row }">
          <div class="table-default__controls table-default__controls--minw">
            <button @click="$emit('edit', row)" type="button">
              <img src="@/assets/img/edit-table-icon.svg" alt="Edit">
            </button>
            <button @click="$emit('delete', row.id)" type="button">
              <img src="@/assets/img/delete-table-icon.svg" alt="Delete">
            </button>
          </div>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            @input="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" :limit="40" />
      </app-cells>
    </template>
  </div>
</template>

<script >
import { getClimbingGroupsCrewPositions } from '@/http'

export default {
  name: 'ClimbingGroupsSupplyDetailEquipment',
  props: ['status', 'updateKey'],
  data() {
    return {
      page_loaded: false,
      table: {
        items: [],
        columns: [
          'name',
          'planned_count',
          'real_count',
          'assigned_count',
          'weight',
        ],
        options: {
          headings: {
            'name': 'Position',
            'planned_count': 'Planned',
            'real_count': 'Real',
            'assigned_count': 'Assigned',
            'weight': 'Weight',
            'controls': '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader: false,
    }
  },
  computed: {
    can_update() {
      return this.$store.state.userGroups.some(group => group.code === 'general_manager') ||
        this.$store.state.userGroups.some(group => group.code === 'climbing_supervisor')
    }
  },
  watch: {
    updateKey() {
      this.fetchItems()
    }
  },
  created() {
    this.fetchItems()
    if (this.can_update) this.table.columns.push('controls')
  },
  methods: {
    async fetchItems() {
      this.table_preloader = true
      const response = await getClimbingGroupsCrewPositions(
        Number(this.$route.params.id),
        { page: this.pagination.page, page_size: 40 }
      )
      this.table.items = response.data.results
      this.pagination.pages = response.data.pages
      this.pagination.count = response.data.count
      this.table_preloader = false
      this.page_loaded = true
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    amountFormat(amount) {
      return Intl.NumberFormat('ru-RU').format(amount)
    },
  }
}
</script>

